import { render } from "./SideMenuItem.vue?vue&type=template&id=64cbd864&scoped=true"
import script from "./SideMenuItem.vue?vue&type=script&lang=js"
export * from "./SideMenuItem.vue?vue&type=script&lang=js"

import "./SideMenuItem.vue?vue&type=style&index=0&id=64cbd864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cbd864"]])

export default __exports__